import { render } from "./index.vue?vue&type=template&id=df7584f8&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=df7584f8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df7584f8"],['__file',"src/views/account_center/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "df7584f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('df7584f8', __exports__)) {
    api.reload('df7584f8', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=df7584f8&scoped=true", () => {
    api.rerender('df7584f8', render)
  })

}


export default __exports__